import { useTLang } from 'intl/intl';

export function useSOCancelDialogLang() {
  return {
    confirmTitle: useTLang({ id: 'scheduleOrder.cancel.confirmTitle' }),
    confirmDescription: useTLang({
      id: 'scheduleOrder.cancel.confirmDescription',
    }),
    confirmBack: useTLang({ id: 'scheduleOrder.cancel.confirmBack' }),
    confirmSubmit: useTLang({ id: 'scheduleOrder.cancel.confirmSubmit' }),
    successToast: useTLang({ id: 'scheduleOrder.cancel.successToast' }),
    errorToast: useTLang({ id: 'scheduleOrder.cancel.errorToast' }),
  };
}
